export default __webpack_public_path__ + "static/media/question_bg.6af00ce9.png";